/**
 * Initializes the chat widget open button functionality.
 *
 * This function looks for an element with the given button ID and attaches
 * a click event listener to it. When clicked, it emits an "open-widget"
 * event to the global `watermelonWidget` (if available).
 *
 * @param buttonId - The ID of the button that should open the chat widget.
 */
function initializeChatWidget(buttonId: string = "openChatButton"): void {
  const button = document.getElementById(buttonId);

  if (!button) {
    console.warn(`Button with id "${buttonId}" not found.`);
    return;
  }

  button.addEventListener("click", () => {
    (window as any).watermelonWidget?.emit("open-widget");
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initializeChatWidget();
});
